/**
 * Drag handle passed to react-nestable's `handler` prop. Nestable clones it
 * with its mouse-down listener, so the element must be a plain span (not a
 * button) and must be rendered via `{handler}` inside renderItem.
 *
 * Same "grip" affordance as the previous Edit-menu screen: the order in which
 * rows are dropped here is the order customers see in the client app.
 */
export const gripHandle = (title) => (
  <span className="menu-tree__grip" title={title} aria-label={title} role="img">
    <i className="fas fa-grip-vertical" aria-hidden="true" />
  </span>
);

/** Yellow folder icon for category / subcategory rows (decorative). */
export const folderIcon = (extraClass) => (
  <span className={`menu-tree__folder ${extraClass || ""}`} aria-hidden="true">
    <i className="fas fa-folder" />
  </span>
);

/** Salmon bullet for product rows (decorative). */
export const bulletIcon = () => <span className="menu-tree__bullet" aria-hidden="true" />;
